// src/components/MobileDrawer.jsx
import { useState } from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";

export default function MobileDrawer() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const items = [
    { label: "Tickets", path: "/app/" },
    { label: "Dashboard", path: "/app/dashboard" },
    { label: "Profile", path: "/app/userprofile" },
    { label: "Help/FAQ", path: "/app/help" },
    // etc.
  ];

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <MenuIcon />
      </IconButton>
      <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 240 }} role="presentation">
          <List>
            {items.map((i) => (
              <ListItemButton
                key={i.path}
                onClick={() => {
                  navigate(i.path);
                  setOpen(false);
                }}
              >
                <ListItemText primary={i.label} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
}
